// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.device

import org.multipaz.cbor.DataItem
import org.multipaz.device.AssertionGenericCbor
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap

fun AssertionGenericCbor.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "S3fzhJjR5kye14U-pAt-gks6W5qId3-Zvs8A0FnLedY")
val AssertionGenericCbor_cborSchemaId = ByteString(75, 119, -13, -124, -104, -47, -26, 76, -98, -41, -123, 62, -92, 11, 126, -126, 75, 58, 91, -102, -120, 119, 127, -103, -66, -49, 0, -48, 89, -53, 121, -42)

fun AssertionGenericCbor.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "GenericCbor")
    builder.put("data", this.data)
    return builder.end().build()
}

fun AssertionGenericCbor_fromDataItem(dataItem: DataItem): AssertionGenericCbor {
    val data = dataItem["data"]
    return AssertionGenericCbor(
        data = data,
    )
}
